<template>
    <div class="col s6 m6">
        <div class="card  white">
            <div class="card-content  gray-text">
                <span class="card-title">
                    <slot name="title"></slot>
                </span>
                <p>
                    <slot name="descricao"></slot>
                </p>
            </div>
            <div class="card-action" style="cursor:pointer;">
                <slot name="action"></slot>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: "BaseCard"
};
</script>
